/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import type { Event, EventComponent } from '../types'

import { cleanupStorage, getStoredComponent, setStoredComponent } from './utils'

const initialState: {
  event?: Event
  component?: EventComponent
} = {
  component: getStoredComponent(),
}

const publicBookingSlice = createSlice({
  name: 'booking_slice',
  initialState,
  reducers: {
    setEvent: (state, action: PayloadAction<Event>) => {
      state.event = action.payload
    },
    setComponent: (state, action: PayloadAction<EventComponent>) => {
      state.component = action.payload
      setStoredComponent(action.payload)
    },
    cleanBooking: state => {
      cleanupStorage()
      return {
        event: state.event,
        availableAddons: {},
        customBookingDate: null,
        customBookingDuration: null,
      }
    },
  },
})

export const {
  cleanBooking, // clear all booking data
  setEvent,
  setComponent,
} = publicBookingSlice.actions
export default publicBookingSlice.reducer
